import type { ComponentProps, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { Card } from '@shieldpay/bumblebee/card';
import { Heading } from '@shieldpay/bumblebee/heading';
import { Column } from '@shieldpay/bumblebee/layout';
import { Text } from '@shieldpay/bumblebee/text';

import { CONTENT_IDS } from '../contents-table/utils';

export interface ComponentPreviewProps
  extends Pick<
    ComponentProps<typeof Card>,
    'alignContent' | 'spacing' | 'padding'
  > {
  children: ReactNode;
  controls?: ReactNode;
}

export const ComponentPreview = ({
  children,
  controls,
  alignContent,
  spacing = 'base',
  padding,
}: ComponentPreviewProps) => {
  return (
    <>
      <Heading level="2" id={CONTENT_IDS.LIVE_DEMO} variant="headline2">
        <FormattedMessage id="hive.titles.liveDemo" />
      </Heading>
      <Card
        style={{
          position: 'relative', // To contain absolutely positioned components, e.g. TopBar
        }}
        alignContent={alignContent}
        spacing={spacing}
        padding={padding}
      >
        {children}

        {controls ? (
          <Column padding={{ top: 'basePos4' }} expand>
            <Card expand spacing="base">
              <Heading variant="bodyMedium150">Configure props</Heading>
              <Text>Adjust configuration on live demo</Text>
              {controls}
            </Card>
          </Column>
        ) : null}
      </Card>
    </>
  );
};
